import { createAsyncRequestTypes } from 'utils'
import { BASE_INFORM_API_URL } from 'services/constants'

export const LOT_SEARCH = '@@LotSearch/'
export const POPULATE_FIELD = `${LOT_SEARCH}POPULATE_FIELD`
export const BLUR = `${LOT_SEARCH}BLUR`
export const FOCUS = `${LOT_SEARCH}FOCUS`
export const CLOSE_SEARCH = `${LOT_SEARCH}CLOSE_SEARCH`
export const EXACT_MATCH_SEARCH = createAsyncRequestTypes(
  `${LOT_SEARCH}EXACT_MATCH_SEARCH`
)
export const PARTIAL_MATCH_SEARCH = createAsyncRequestTypes(
  `${LOT_SEARCH}PARTIAL_MATCH_SEARCH`
)
export const FIND_NEXT = createAsyncRequestTypes(`${LOT_SEARCH}FIND_NEXT`)
export const FIND_PREV = createAsyncRequestTypes(`${LOT_SEARCH}FIND_PREV`)
export const TOGGLE_FILTER = `${LOT_SEARCH}TOGGLE_FILTER`
export const GET_TOOLTIP = createAsyncRequestTypes(`${LOT_SEARCH}GET_TOOLTIP`)
export const GET_SEARCH_FILTERS = createAsyncRequestTypes(
  `${LOT_SEARCH}GET_SEARCH_FILTERS`
)

export const LOT_PARTIAL_MATCH_SEARCH_URL = `${BASE_INFORM_API_URL}/search/lotpartialmatch`
export const LOT_EXACT_MATCH_SEARCH_URL = `${BASE_INFORM_API_URL}/search/lotexactmatch`

export const OPEN_FILTERS_GRID = `${LOT_SEARCH}OPEN_FILTERS_GRID`
export const CLOSE_FILTERS_GRID = `${LOT_SEARCH}CLOSE_FILTERS_GRID`
export const CLEAR_FILTER_FIELD = `${LOT_SEARCH}CLEAR_FILTER_FIELD`
export const SET_TEXT_FILTER_FIELD = `${LOT_SEARCH}SET_TEXT_FILTER_FIELD`
export const RESET_FILTERS = `${LOT_SEARCH}RESET_FILTERS`
export const CLEAR_SEARCH = `${LOT_SEARCH}CLEAR_SEARCH`

export const FOUND_INVALID_VALUES = `${LOT_SEARCH}FOUND_INVALID_VALUES`
export const FOUND_INVALID_VALUES_REJECTED = `${LOT_SEARCH}FOUND_INVALID_VALUES_REJECTED`
